import { Link } from "gatsby"
import React from "react"
import { Button, Card, Col, Row } from "react-bootstrap"

function ProductCard({ title, onSale, price, image, slug }) {
  return (
    <Link style={{ textDecoration: "none", color: "#000000" }} to={slug}>
      <Card
        className="product-card"
        style={{ maxWidth: 240, margin: "10px auto" }}
      >
        <Card.Img variant="top" src={`/products/${image}`} />
        <Card.Body>
          <Card.Title className="p">{title}</Card.Title>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <p className="m-0 text-danger font-weight-bold">{onSale}</p>
            <p className="m-0 text-secondary font-weight-bold">
              <s> {price} </s>
            </p>
          </div>
        </Card.Body>
      </Card>
    </Link>
  )
}

export default function ProductCards({ products }) {
  console.log(products)
  return (
    <Row className="mt-5">
      {products.map((product: any, index: number) => {
        return (
          <Col sm={6} md={4} lg={3} key={index}>
            <ProductCard
              title={product.node.frontmatter.title}
              onSale={product.node.frontmatter.onSale}
              price={product.node.frontmatter.price}
              image={product.node.frontmatter.image}
              slug={product.node.frontmatter.slug}
            />
          </Col>
        )
      })}
    </Row>
  )
}
